import { error } from 'util';
import { StateService } from '@uirouter/core';
import * as angular from 'angular';
import _ = require('underscore');
import { NotificationService } from '../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../app.common/modules/common/services/popup.service';
import { IngredientsService } from '../../common/services/ingredients.service';
import { IIngredient } from '../../model/ingredients/IIngredient';
import { IIngredientSearchFilter } from '../../model/ingredients/IIngredientSearchFilter';

export class IngredientsTabs {

    public static $inject = [
        '$uibModal',
        '$state',
        '$translate',
        'notificationService',
        'popupService',
        'ingredientsService',
    ];

    public search = {
        placeholder: '' as string,
        text: '' as string
    };

    public waiting: boolean = false;
    public canLoadMore: boolean = true;
    public ingredients: IIngredient[] = [];
    public total: number = 0;
    public forSearch: boolean = false;
    public searchMessageContent: string = '';
    public itemsLimit: number = 20;
    public isActive: boolean = true;

    constructor(
        private $uibModal: ng.ui.bootstrap.IModalService,
        private $state: StateService,
        private $translate: angular.translate.ITranslateService,
        private notificationService: NotificationService,
        private popupService: PopupService,
        private ingredientsService: IngredientsService,
    ) {
        this.isActive = $state.params.isActive;
    }

    public async $onInit() {
        this.loadData(false);
    }

    public loadData(forSearch: boolean) {
        if (this.waiting || !this.canLoadMore) {
            return;
        }

        this.forSearch = forSearch;
        this.waiting = true;

        this.notificationService.showWaitingMessage();

        const filter: IIngredientSearchFilter = {
            archived: !this.isActive,
            searchTerm: this.search.text,
            limit: this.itemsLimit,
            searchAfterID: this.ingredients.length ? _.last(this.ingredients).ID : null
        };

        this.ingredientsService.getIngredients(filter)
            .then((ingredientsResponse) => {

                this.total = ingredientsResponse.Total;
                const ingredients: IIngredient[] = ingredientsResponse.Items;

                Array.prototype.push.apply(this.ingredients, ingredients);
                this.waiting = false;
                this.canLoadMore = ingredientsResponse.Items.length === this.itemsLimit;

                if (this.ingredients.length > 0) {
                    return;
                }

                if (this.search.text && forSearch) {
                    this.searchMessageContent = this.$translate.instant('ingredients_list_not_found_screen_content', {search: this.search.text});
                }
                this.notificationService.clearAll();
            })
            .catch((error) => this.notificationService.showErrorMessage(error))
            .finally(() => {
                this.waiting = false;
                this.notificationService.clearAll();
            });
    }

    public async deleteIngredient(ingredient: IIngredient) {
        try {
            const result = await this.popupService.confirm({
                title: this.$translate.instant('archive_ingredient'),
                content: `<span style="word-break: break-all">${this.$translate.instant('archive_ingredient_content', {ingredientTitle: ingredient.Title}  )}</span>`,
                cancelClass: 'btn btn-with-icon btn-in-popup-footer',
                okClass: 'btn btn-with-icon btn-with-icon--before-delete btn-danger flexVerticalAlignParent',
                classPopup: 'popup--redesign modal360',
                cancelTxt: this.$translate.instant('cancel'),
                okTxt: this.$translate.instant('button_archive'),
                hasIcon: true
            });
            try {
                await this.ingredientsService.archiveIngredient(ingredient.ID);
            } catch (error) {
                this.notificationService.showErrorMessage();
            }
            this.resetList();
            this.loadData(false);

        } catch (error) {
            this.waiting = false;
            return;
        }
    }

    public async openIngredientDialog(ingredient: IIngredient) {
        let operationResult;
        try {
            operationResult = await this.$uibModal.open({
                component: 'ingredientDialog',
                resolve: {
                    ingredient: () => ingredient
                },
                size: 'md',
                backdrop: 'static'
            }).result;
            if (operationResult && operationResult.status === 'ok') {
                this.resetList();
                this.loadData(false);
             }
        } catch (e) {
            return;
        }
    }

    public applySearch(searchText: string) {
        this.search.text = searchText;
        this.resetList();
        this.loadData(searchText.length > 0);
    }

    public async resetSearch() {
        this.search.text = '';
        this.applySearch('');
    }

    public async restoreIngredient(ingredient: IIngredient) {
        try {
            const result = await this.popupService.confirm({
                title: this.$translate.instant('ingredient_restore_title'),
                content: `<span style="word-break: break-all">${this.$translate.instant('ingredient_restore_content')}</span>`,
                cancelClass: 'btn btn-with-icon btn-in-popup-footer',
                okClass: 'btn btn-with-icon btn-with-icon--before-restore btn-success flexVerticalAlignParent',
                classPopup: 'popup--redesign modal360',
                cancelTxt: this.$translate.instant('cancel'),
                okTxt: this.$translate.instant('restore'),
                hasIcon: true
            });
            try {
                await this.ingredientsService.restoreIngredient(ingredient.ID);
            } catch (error) {
                this.notificationService.showErrorMessage();
            }
            this.resetList();
            this.loadData(false);
        } catch (error) {
            this.waiting = false;
            return;
        } finally {
            this.notificationService.clearAll();
        }
    }

    public setTab(tabName: string) {
        this.isActive = tabName === 'active';
        this.resetList();
        this.resetSearch();

        if (this.isActive) {
            this.$state.go('app.activeIngredients', { isActive: true });
        } else {
            this.$state.go('app.archivedIngredients', { isActive: false });
        }
    }

    private resetList() {
        this.canLoadMore = true;
        this.total = 0;
        this.ingredients = [];
    }
}

angular.module('naut').component('ingredientsTabs', {
    template: require('./ingredients-tabs.component.html'),
    controller: IngredientsTabs,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/ingredients/tabs-list/ingredients-tabs.component.ts